module.exports = __webpack_public_path__ + "static/media/indostar.3989ee7f.svg";